import { FC, useState, type RefCallback } from "react";
// import lottie from "lottie-web";
// import Lottie from "react-lottie-player";
import { DotLottieReact, type DotLottie } from "@lottiefiles/dotlottie-react";

import "./LottieAnimation.css";

interface LottieAnimationProps {
  src: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  loop?: boolean;
  autoplay?: boolean;
  scale?: number; // Add scale to crop internal padding
  marginTop?: string; // e.g., "-10%" to crop from top
  marginBottom?: string; // e.g., "-10%" to crop from bottom
}

export const LottieAnimation: FC<LottieAnimationProps> = ({
  src,
  className = "",
  width = "100%",
  height,
  loop = true,
  autoplay = true,
  scale = 1,
  marginTop,
  marginBottom,
}: LottieAnimationProps) => {
  // const [animationData, setAnimationData] = useState<object>();

  const [, setDotLottie] = useState<DotLottie | null>(null);

  const dotLottieRefCallback: RefCallback<DotLottie | null> = (instance: any) => {
    setDotLottie(instance);
  };

  return (
    <div
      className={`lottie-animation-container ${className}`}
      style={{
        width,
        ...(height ? { height } : {}),
        ...(scale !== 1 ? { transform: `scale(${scale})` } : {}),
        ...(marginTop ? { marginTop } : {}),
        ...(marginBottom ? { marginBottom } : {}),
      }}
    >
      <DotLottieReact
        className={`lottie-animation ${className}`}
        {...(width ? { width } : {})}
        {...(height ? { height } : {})}
        src={src}
        autoplay={autoplay}
        loop={loop}
        dotLottieRefCallback={dotLottieRefCallback}
      />
    </div>
  );
};
